<template>
  <div class="form-panel" v-if="isShow">
    <van-form class="from" input-align="left">
      <template v-for="(item, index) in list">
        <!-- limit对应van-field组件中的type -->
        <van-field
          v-model="item.value"
          :label="item.label"
          :required="item.require==1"
          :placeholder="item.placeholder?item.placeholder:'请输入'+item.label"
          rows="1"
          autosize
          v-if="item.type =='text'"
          :type="item.limit?item.limit:'textarea'"
          :readonly="item.readonly==1"
          :maxlength="item.maxlength || '-'"
          @input="onInput($event,item)"
          :key="index"
        >
          <template v-if="item.hasSmsCode" #button>
            <van-button @click="getSms()" :color="themeColor" size="mini" :disabled="smsCodeDisabled">{{smsCodeTxt}}</van-button>
          </template>
        </van-field>
        <van-field
          v-model="item.value"
          :label="item.label"
          :required="item.require==1"
          :placeholder="item.placeholder?item.placeholder:'请输入'+item.label"
          rows="2"
          autosize
          :maxlength="item.maxlength || '500'"
          v-if="item.type =='textarea'"
          :type="item.limit?item.limit:'textarea'"
          :readonly="item.readonly==1"
          :key="index"
        />
        <template v-if="item.type =='select'">
          <template v-if="item.name == 'province_id'"></template>
          <van-field v-else-if="item.name == 'city_id'" readonly label="医院所在地" :required="item.require==1" v-model="address" @click="(item.readonly==1)?'':(showAddress = true)" :right-icon="(item.readonly==1)?'':'arrow-down'" rows="1" autosize type="textarea" :key="index" />
          <van-field v-else-if="item.name == 'hospital_id'" readonly label="医院名称" :required="item.require==1" v-model="hospital" @click="(item.readonly==1)?'':(showHospital = true)" :right-icon="(item.readonly==1)?'':'arrow-down'" rows="1" autosize type="textarea" :key="index" />
          <div v-else :key="index">
            <van-field readonly :label="item.label" :required="item.require==1" v-model="item.value" :placeholder="item.placeholder?item.placeholder:'请选择'+item.label" @click="openPopup(index)" :right-icon="(item.readonly==1)?'':'arrow-down'" rows="1" autosize type="textarea" />
            <van-popup class="docpc-picker-bottom" v-model="item.showOption" position="center" :style="{ height: '400px',minWidth: '320px' }" @click-overlay="closePopup(index)">
              <van-icon class="docpc-picker-close" size="22" name="cross" @click="closePopup(index)" />
              <form action="/">
                <van-search v-model="item.keyword" placeholder="请输入搜索关键词" show-action @search="onSearch(index, item.keyword)" @clear="clearSearch(index, item.keyword)">
                  <template #action>
                    <div class="search-btn" @click="onSearch(index, item.keyword)">搜索</div>
                  </template>
                </van-search>
                <van-picker :default-index="findIndex(item.option, item.value)" show-toolbar toolbar-position="bottom" :columns="getOption(item.option, item.keyword)" value-key="value" :style="{height:'246px'}" @cancel="closePopup(index)" @confirm="confirm(index, $event)" />
              </form>
            </van-popup>
          </div>
        </template>
        <van-field
          :label="item.label"
          :required="item.require==1"
          readonly
          name="picker"
          :value="item.value"
          :placeholder="item.placeholder?item.placeholder:'点击选择'+item.label"
          @click="showPick(item,index)"
          v-if="item.type =='radio'"
          right-icon="arrow-down"
          :key="index"
        />
        <van-field
          :label="item.label"
          :required="item.require==1"
          name="checkboxGroup"
          v-if="item.type =='checkbox'"
          :key="index"
        >
          <template #input>
            <van-checkbox-group
              v-model="item.value"
              :max="item.select_count"
            >
              <template v-for="(checkItem, checkIndex) in item.options">
                <van-checkbox
                  :name="checkItem"
                  shape="square"
                  style="margin-bottom:5px"
                  :disabled="item.readonly==1"
                  :key="checkIndex"
                >
                  {{checkItem}}
                </van-checkbox>
              </template>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field
          :label="item.label"
          :required="item.require==1"
          readonly
          clickable
          name="datetimePicker"
          :value="item.value"
          :placeholder="item.placeholder?item.placeholder:'点击选择'+item.label"
          @click="openTime(item,index)"
          v-if="item.type =='date'"
          :key="index"
        />
        <template v-if="item.type =='daterange'">
          <van-field
            :label="item.label"
            :required="item.require==1"
            readonly
            clickable
            name="calendar"
            :value="item.value.time"
            placeholder="点击选择区间"
            @click="difPick(item,index)"
            :key="index"
          />
          <van-field
            :label="item.daterange_diff?item.daterange_diff:item.label"
            :required="item.require==1"
            readonly
            clickable
            name="calendar"
            :value="item.value.day?item.value.day+'天':''"
            placeholder="__天"
            :key="index"
          />
        </template>

        <Upload
          v-if="item.type =='file'"
          :item="item"
          @getimg="getimg"
          :key="index"
        ></Upload>
      </template>
    </van-form>
    
    <!-- <div class="btn">
      <van-button
        round
        type="info"
        :disabled="disabled"
        native-type="submit"
        @click="next"
      >下一步
      </van-button>
    </div>
    <div
      class="goBack"
      @click="back"
    >
      <img src="/static/goBack.png" />
    </div> -->

    <van-popup
      v-model="timePicker"
      position="bottom"
    >
      <van-datetime-picker
        :type="timeType"
        @confirm="timeConfirm"
        @cancel="timeCancel"
        v-model="time"
      />
    </van-popup>
    <van-popup
      v-model="showPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="pickConfirm"
        @cancel="pickCancel"
      />
    </van-popup>
    <van-calendar
      v-model="showDif"
      type="range"
      @confirm="difConfirm"
      @close="difClose"
      :minDate="minDate"
    />
    <van-popup v-model="showAddress" round position="bottom">
      <van-picker show-toolbar :columns="addressArr" @cancel="showAddress = false" @confirm="onConfirm" />
    </van-popup>
    <van-popup v-model="showHospital" round position="bottom">
      <van-picker show-toolbar :columns="hospitalArr" @cancel="showHospital = false" @confirm="onHospital"
        value-key="name" />
    </van-popup>
  </div>
</template>

<script>
  import Upload from '@/doctor_pc/components/upload/upload.vue'
  import {
    Toast
  } from "vant";
  import {
    checkCellphone,
    isIdCardNo,
    checkMail,
    getAge,
    getSexById
  } from '@/utils/utils'
  import { SendVerifyCode } from '@/api/doctorapi';
  import {
    provinceCity,
    hospital,
    submit,
  } from '@/api/api'

  export default {
    components: {
      Upload,
    },
    name: '',
    props: {
      arr: {
        type: Array,
        default: () => []
      },
      formHandle: {
        type: Array,
        default: () => []
      },
    },
    computed: {
      list() {
        return this.arr
      },
    },
    data() {
      return {
        themeColor: this.themeColor,
        isShow: false,
        disabled: false,
        showDif: false,
        timePicker: false,
        showPicker: false,
        jobPicker:false,
        columns: [],
        minDate: new Date(2010, 0, 0),
        maxDate: '',
        name: '', //正在操作哪一个
        timeType: 'date',
        time: new Date(),
        showAddress: false,
        showHospital: false,
        address: '',
        hospital: '',
        addressArr: [],
        hospitalArr: [],
        province_id: null,
        city_id: null,
        hospital_id: null,
        timer: null,
        smsCodeTxt: '发送验证码',
        smsCodeDisabled: false,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      async init() {
        for(let i in this.list) {
          let ele = this.list[i]
          if (ele.type == 'select') {
            // if (ele.name == 'province_id') {
            //   this.province_id = ele.value
            // } else if (ele.name == 'city_id') {
            //   this.city_id = ele.value
            // } else if (ele.name == 'hospital_id') {
            //   this.hospital_id = ele.value
            // }
            if (ele.hasOwnProperty('option')) {
              ele.showOption = false
              ele.keyword = ''
            }
          }
        }
        console.log('init', this.list)
        // await this.getAddress()
        // if(this.province_id && this.city_id) {
        //   await this.getHospital()
        // }
        this.isShow = true
      },
      async getAddress() {
        let pname = '',
            cname = '',
            hname = '';
        this.addressArr = await provinceCity()
        for (let j in this.addressArr) {
          let elej = this.addressArr[j]
          if (elej.id == this.province_id) {
            pname = elej.text
            for (let k in elej.children) {
              let elek = elej.children[k]
              if (elek.id == this.city_id) {
                cname = elek.text
              }
            }
          }
        }
        this.address = pname && cname ? pname + '/' + cname : ''
      },
      async getHospital() {
        let {
          items
        } = await hospital({
          params: {
            province_id: this.province_id,
            city_id: this.city_id
          }
        })
        this.hospitalArr = items
        if (this.hospital_id) {
          for(let i in this.hospitalArr) {
            let ele = this.hospitalArr[i]
            if (ele.id == this.hospital_id) {
              this.hospital = ele.name
            }
          }
        }
      },
      getSms() {
        let item = null
        for(let i in this.list) {
          let ele = this.list[i]
          if (ele.name=='mobile' && ele.hasSmsCode) {
            item = ele
          }
        }
        if(item) {
          console.log(item.value)
          let self = this;
          if (!item.value) {
            Toast('请输入'+item.label)
            return false;
          } else if (!checkCellphone(item.value)) {
            Toast(item.label+'格式有误')
            return false;
          }

          SendVerifyCode({
            mobile: item.value
          }).then((res) => {
            if (res.data.isValid) {
              Toast(res.data.resultContent)
              self.startTimer();
            } else {
              Toast(res.data.resultContent)
            }
          }).catch((err) => {
            Toast('手机号格式有误')
          });
        }
      },
      startTimer() {
        this.smsCodeDisabled = true;
        let seconds = 60;
        this.timer = setInterval(() => {
          seconds--;
          this.smsCodeTxt = seconds + "秒";
          if (seconds <= 0) {
            clearInterval(this.timer);
            this.smsCodeTxt = "重发验证码";
            this.smsCodeDisabled = false;
          }
        }, 1000);
      },
      confirm(index, e) {
        let item = this.list[index]
        if (item.name == 'hospital' && item.option.length == 0) {
          Toast('请先输入关键字搜索医院！')
          return
        }
        item.value = e.value
        console.log('confirm',item, e)
        this.closePopup(index)
      },
      openPopup(index) {
        let item = this.list[index]
        if (item.readonly==1) {
          return
        }
        item.showOption = true
        this.$forceUpdate()
      },
      closePopup(index) {
        let item = this.list[index]
        item.showOption = false
        this.$forceUpdate()
      },
      findIndex(arr, val) {
        for (let i in arr) {
          let ele = arr[i]
          if (ele.name == ele.val) {
            // console.log('findIndex', i)
            this.$forceUpdate
            return i
          }
        }
      },
      async onSearch(index, val) {
        let item = this.list[index]
        item.keyword = val
        this.$emit('onSearch', item)
        this.$forceUpdate()
      },
      clearSearch(index, val) {
        let item = this.list[index]
        item.keyword = ''
        this.$forceUpdate()
      },
      getOption(list , val) {
        let arr = list.filter(item => {
          if (item.value){ 
            return item.value.indexOf(val) != -1
          } else if (item.name) {
            return item.name.indexOf(val) != -1
          }
        })
        // console.log('getOption', arr)
        return arr
      },
      onConfirm(value, index) {
        let provinceIndex = index[0]
        let cityIndex = index[1]
        this.showAddress = false
        if ((value[0] + '/' + value[1]) != this.address) {
            this.hospital = ''
            this.hospital_id = ''
        }
        this.address = value[0] + '/' + value[1]
        this.province_id = this.addressArr[provinceIndex].id
        this.city_id = this.addressArr[provinceIndex].children[cityIndex].id
        this.getHospital()
        for(let i in this.list) {
          let ele = this.list[i]
          if (ele.name == 'province_id') {
            ele.value = this.province_id
          } else if (ele.name == 'city_id') {
            ele.value = this.city_id
          } else if (ele.name == 'hospital_id') {
            ele.value = this.hospital_id
          }
        }
      },
      onHospital(value, index) {
        // console.log(value, index)
        this.showHospital = false
        this.hospital = value.name
        this.hospital_id = value.id
        for(let i in this.list) {
          let ele = this.list[i]
          if (ele.name == 'hospital_id') {
            ele.value = this.hospital_id
          }
        }
      },
      formCheck(value) {
        if (value.length <= 0) return 'error'
        for(let i in value) {
          let ele = value[i]
          if (ele.require) {
            if (ele.type == 'checkbox' && ele.type == 'file') {
              if (ele.value.length) {
                Toast('请完善信息')
                return 'error'
              }
            } else {
              if (!ele.value) {
                Toast('请完善信息')
                return 'error'
              } else {
                if (ele.name == 'idsn' && !isIdCardNo(ele.value)) {
                  Toast(ele.label+'格式有误')
                  return 'error'
                } else if (ele.name == 'mobile' && !checkCellphone(ele.value)) {
                  Toast(ele.label+'格式有误')
                  return 'error'
                } else if (ele.name == 'email' && !checkMail(ele.value)) {
                  console.log(ele.value)
                  Toast(ele.label+'格式有误')
                  return 'error'
                }
              }
            }
          }
        }
      },
      change() {
        this.$emit('change', this.list)
        return;
      },
      next() {
        if (this.formCheck(this.list) != 'error') {
          this.$emit('confirm', this.list)
        }
        return;
      },
      onInput(event, item) {
        if (item.name == 'idsn' && event.length == 18) {
          // let input = this.list[0].input
          // let index = input.findIndex(ele => ele.name == 'gender')
          // console.log('onInput', index)
          // let sex = getSexById(event)
          // if (index != -1) this.list[0].input[index].value = sex
          // let age = getAge(event)
          // index = input.findIndex(ele => ele.name == 'age')
          // if (index != -1) this.list[0].input[index].value = age
        }
      },
      getimg() {

      },
      back() {
        this.$emit('step', 'back')
      },
      afterRead(file) {
        console.log(file, 'file')
      },
      difClose() {
        this.index = null
      },
      formatDate(date) {
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      },
      difPick(item, index) {
        if (item.readonly==1) return false
        this.name = item.name
        this.showDif = true
      },
      difConfirm(date) {
        const [start, end] = date;
        this.showDif = false;
        for (let i in this.list) {
            let input = this.list[i].input
            let index = input.findIndex(ele => ele.name == this.name)
            if (index != -1) {
                this.list[i].input[index].value = {
                    time: `${this.formatDate(start)} - ${this.formatDate(end)}`,
                    day: new Date(end - start) / (1000 * 60 * 60 * 24) + 1
                }
            }
        }
        this.index = null
      },
      openTime(item, index) {
        if (item.readonly==1) return false
        this.timePicker = true
        if (item.date_precision == 'month') {
            this.timeType = 'year-month'
        } else {
            this.timeType = 'date'
        }
        this.name = item.name
      },
      timeCancel() {
        this.name = ''
        this.timePicker = false
      },
      timeConfirm(value) {
        const d = new Date(value)
        let time = ''
        if (this.timeType == 'date') {
            time = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        } else {
            time = d.getFullYear() + '-' + (d.getMonth() + 1)
        }
        // console.log(time, 'time')
        for (let i in this.list) {
            let input = this.list[i].input
            let index = input.findIndex(ele => ele.name == this.name)
            if (index != -1) {
                this.list[i].input[index].value = time
            }

        }
        this.timePicker = false
        this.name = ''

      },
      showPick(item, index) {
        if (item.readonly==1) return false
        // console.log(item, index)
        this.columns = item.options
        this.showPicker = true
        this.name = item.name
        console.log(this.name)
      },
      pickConfirm(value) {
        for (let i in this.list) {
          let input = this.list[i].input
          let index = input.findIndex(ele => ele.name == this.name)
          if (index != -1) {
              this.list[i].input[index].value = value
          }
        }
        this.name = ''
        this.time = ''
        this.showPicker = false
      },
      pickCancel() {
        this.timePicker = false
        this.name = ''
      },
    }
  }
</script>

<style lang="scss" scoped>
.form-panel {
  // padding: 0 11px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
  // margin-bottom: 70px;

  .title {
    padding-left: 11px;
    box-sizing: border-box;
    font-size: 15px;
    color: #232323;
    margin-bottom: 13px;
    text-align: left;
  }

  .from {
    margin-bottom: 30px;
  }
}
</style>